module.exports = __webpack_public_path__ + "static/media/stepper-curate-active.aecbb17e.svg";